import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled, { css } from 'styled-components';
import { Row, Button, Separator, Text, Col } from '@cuemath/comps';
import { Header } from 'semantic-ui-react';
import { closeModal } from 'actions/modal';
import COLORS from 'constants/colors';
import {
  FORM_DATA,
  UPLOAD_WORKBOOK_DISPATCH,
  UPLOAD_DISPATCH_TEXT,
  UPLOADED_FILE_CONTAINS_ERRORS,
  SUCCESSFULLY_SUBMITTED,
  PLEASE_SELECT_FILE,
  NOTE_FOR_ERROR_COLUMN,
  SOMETHING_WENT_WRONG,
  MULTIPLE_FORM_DATA,
  POST,
  CONTENT_TYPE,
  CSV_CONTENT_TYPE,
  CONTENT_DISPOSITION,
  CSV_LINK,
} from 'constants/workbook-management';
import PropTypes from 'prop-types';
import { CSVLink } from 'react-csv';
import { ButtonWrapper, Field, Head, Message } from 'modules/form';
import axios from 'axios';

const Wrapper = styled.div`
  max-height: 500px;
`;

const FormWrapper = styled.div`
  padding: 20px;
  text-align: center;
`;

const TextWrapper = styled(Text)`
  font-size: 16px;
  ${({ paddingLeft }) =>
    paddingLeft &&
    css`
      padding-left: ${paddingLeft}px;
    `};
`;

const HeadWrapper = styled(Head)`
  border-bottom: 1px solid ${COLORS.DARK_CHARCOAL};
`;

const CSVLinkWrapper = styled(CSVLink)`
  display: none;
`;

class WorkbookDispatchedUploadModal extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      closeModal: PropTypes.func.isRequired,
    }).isRequired,
    heading: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      errorText: null,
      file: null,
      message: null,
      workbookDispatchData: '',
      noteMsg: null,
      formData: null,
      filename: null,
    };

    this.csvLink = React.createRef();
    this.closeModalTimer = false;
  }

  componentWillUnmount() {
    if (this.closeModalTimer) {
      clearTimeout(this.closeModalTimer);
      this.closeModalTimer = null;
    }
  }

  bakeFormData = () => {
    const { file } = this.state;

    const { FILE } = FORM_DATA || {};
    this.setState({
      errorText: null,
    });

    const formData = new FormData();
    formData.append(FILE, file);

    return formData;
  };

  onChangeFunc = event => {
    const { target } = event || {};
    const { files } = target || {};

    const file = Array.from(files) && files.length ? files[0] : null;

    this.setState({
      file,
      errorText: null,
    });
  };

  usageFunc = heading => {
    return (
      <Row>
        <TextWrapper display="inline">
          <li>
            Use this facility only to{' '}
            <TextWrapper display="inline" weight="semibold">
              upload dispatched{' '}
            </TextWrapper>
            workbooks{' '}
          </li>
        </TextWrapper>
      </Row>
    );
  };

  uploadFilesFunc = () => {
    return (
      <Row>
        <Col xs={3} gutter={0} gap={0}>
          {' '}
          <Text display="inline">
            <li>{UPLOAD_DISPATCH_TEXT}</li>
          </Text>
        </Col>
        <Col xs={9}>
          <Field key="fileUpload">
            <input
              name="fileUpload"
              id="inputFile"
              placeholder="Upload File"
              type="file"
              onChange={this.onChangeFunc}
              onClick={event => {
                event.target.value = null;
              }}
              required={true}
              accept=".csv,text/csv"
            />
          </Field>
        </Col>{' '}
      </Row>
    );
  };

  fetchFilenameFromHeaders = headers => {
    let splittedFilename;

    if (headers && headers[CONTENT_DISPOSITION]) {
      splittedFilename = headers[CONTENT_DISPOSITION].split('=');
      if (Array.isArray(splittedFilename) && splittedFilename.length === 2) {
        const filename = splittedFilename[1];
        this.setState({ filename });
      }
    }
  };

  onSubmitFunc = async event => {
    const { actions } = this.props;
    const { file } = this.state;

    event.preventDefault();

    const formData = this.bakeFormData();

    if (!file) {
      this.setState({ errorText: PLEASE_SELECT_FILE });
      return;
    }

    this.setState({ workbookDispatchData: '', errorText: null, noteMsg: null });

    await axios
      .request({
        method: POST,
        url: UPLOAD_WORKBOOK_DISPATCH,
        data: formData,
        headers: {
          encType: MULTIPLE_FORM_DATA,
        },
      })
      .then(res => {
        const { data, headers } = res || {};
        this.setState({ filename: null });
        this.fetchFilenameFromHeaders(headers);

        this.setState({ errorText: null });

        if (data && headers && headers[CONTENT_TYPE].includes(CSV_CONTENT_TYPE)) {
          this.setState({
            errorText: UPLOADED_FILE_CONTAINS_ERRORS,
            workbookDispatchData: data,
            noteMsg: NOTE_FOR_ERROR_COLUMN,
          });

          const ele = document.getElementById(CSV_LINK);
          if (ele) {
            ele.click();
          }
        } else {
          this.setState({ errorText: null, message: SUCCESSFULLY_SUBMITTED });
          this.closeModalTimer = setTimeout(() => {
            actions.closeModal();
          }, 3000);
        }
      })
      .catch(err => {
        const { response } = err || {};
        const { data } = response || {};
        const { error: dataError } = data || {};
        const { message } = dataError || {};

        this.setState({ errorText: message || SOMETHING_WENT_WRONG });
      });
  };

  renderButton = () => {
    const { workbookDispatchData, filename } = this.state;

    return (
      <Header floated="left">
        <ButtonWrapper flexDirection="row-reverse">
          <CSVLinkWrapper
            data={workbookDispatchData}
            filename={filename}
            uFEFF={false}
            id={CSV_LINK}
          >
            Submit
          </CSVLinkWrapper>

          <Button label="Submit" onClick={e => this.onSubmitFunc(e)} />
        </ButtonWrapper>
      </Header>
    );
  };

  render() {
    const { errorText, message, noteMsg } = this.state;
    const { heading } = this.props;

    return (
      <Wrapper>
        <HeadWrapper>
          <Text size="xlarge" align="center">
            {heading}
          </Text>
        </HeadWrapper>
        <Separator transparent height={25} />
        <FormWrapper width="100%">
          {this.usageFunc(heading)}
          <Separator transparent height={25} />
          {this.uploadFilesFunc()}
          {errorText && (
            <Message width="100%" error>
              {errorText}
              {noteMsg && <Row justifyContent="center">{noteMsg}</Row>}
            </Message>
          )}
          {message && <Message width="100%">{message}</Message>}
          <Separator transparent height={25} />
          {this.renderButton()}
        </FormWrapper>
      </Wrapper>
    );
  }
}

export default connect(null, dispatch => ({
  actions: bindActionCreators(
    {
      closeModal,
    },
    dispatch,
  ),
}))(WorkbookDispatchedUploadModal);
